import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';

import type { Action } from 'types';
import type { SOVQueryLocal, SOVQueryMergedState } from 'modules/insights/sov/types';

const QUERIES_MERGED_UPDATED = 'sov/QUERIES_MERGED_UPDATED';
const QUERIES_MERGED_RESET = 'sov/QUERIES_MERGED_RESET';

const initialState = {
  queriesMerged: []
};

export const updateMergedQueries = (queriesMerged: Array<Partial<SOVQueryLocal>>): Action => ({
  type: QUERIES_MERGED_UPDATED,

  payload: {
    queriesMerged
  }
});

export const resetMergedQueries = (): Action => ({
  type: QUERIES_MERGED_RESET
});

const handleMergedUpdated = (state: SOVQueryMergedState, { queriesMerged }): SOVQueryMergedState => ({
  ...state,
  queriesMerged
});

export default createReducer<SOVQueryMergedState, any>('sovQueries', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [QUERIES_MERGED_RESET]: () => initialState,
  [QUERIES_MERGED_UPDATED]: handleMergedUpdated
});
